import { useEffect } from "react";
import {
  LOCAL_MIC_KEY,
  LOCAL_CAM_KEY,
  LOCAL_SPEAKER_KEY,
} from "modules/audioVideo/constants";
import { useDaily, useDevices as useDailyDevices } from "@daily-co/daily-react";

export const DeviceLoader = () => {
  const daily = useDaily();
  const { setMicrophone, setCamera, setSpeaker } = useDailyDevices();

  useEffect(() => {
    if (!daily) return;

    const audioInputDeviceId = localStorage.getItem(LOCAL_MIC_KEY);
    if (audioInputDeviceId) setMicrophone(audioInputDeviceId);

    const videoInputDeviceId = localStorage.getItem(LOCAL_CAM_KEY);
    if (videoInputDeviceId) setCamera(videoInputDeviceId);

    const audioOutputDeviceId = localStorage.getItem(LOCAL_SPEAKER_KEY);
    if (audioOutputDeviceId) setSpeaker(audioOutputDeviceId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [daily]);

  return null;
};
